module.exports = __webpack_public_path__ + "static/media/9@2x.a405079c.png";